<template>
    <u-tabs-border v-model="TabsQuarternaryValue" v-bind="$attrs" @change="TabsQuarternaryValueChange" class="pb-10px pb-md-16px">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-tabs-border>
</template>

<script>
import UTabsBorder from "@/components/publish/styles/tabs/u-tabs-border.vue";

export default {
    props: {
        value: { type: [Number, String] },
    },
    components: {
        UTabsBorder,
    },
    data() {
        return {
        };
    },
    computed: {
        TabsQuarternaryValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("change", newValue);
            },
        },
    },
    mounted() {},
    methods: {
        TabsQuarternaryValueChange(newValue) {
            this.TabsQuarternaryValue = newValue;
        },
    },
};
</script>

<style lang="scss" scoped></style>
